// src/data/categories.js
import { client } from '../lib/sanity'

export async function getCategories() {
  const query = `*[_type == "category"]{
    _id,
    name,
    subcategories
  }`

  const categories = await client.fetch(query)
  return categories
}
